import type { KgInsight } from '@api';
import React from 'react';

import { CompanyCatalystBadge } from '../company-catalyst-badge/CompanyCatalystBadge';
import { ThematicCatalystBadge } from '../thematic-catalyst-badge/ThematicCatalystBadge';
import { KgInsightHeaderButton } from './KgInsightHeaderButton';
import styles from './KgInsightPreview.module.scss';

export type KgInsightHeaderActionProps = {
  subject: KgInsight['subject'];
};

export const KgInsightHeaderAction = ({
  subject,
}: KgInsightHeaderActionProps) => {
  const catalystBadgeByMode: Partial<
    Record<KgInsight['subject']['type'], React.ReactNode>
  > = {
    entity: <CompanyCatalystBadge entityTag={subject.id} />,
    theme: <ThematicCatalystBadge themeId={subject.id} />,
    geo: <CompanyCatalystBadge entityTag={subject.id} />,
  };

  return (
    <div className={styles.headerActionWrapper}>
      {catalystBadgeByMode[subject.type]}
      <KgInsightHeaderButton subject={subject} />
    </div>
  );
};
